import type { InboxConversationFragment } from "@qw/graphql";

/**
 * The id of the newest message in a thread, used as the reference message for a conversation-level
 * Reply/Reply-all/Forward.
 *
 * The detail view unions a collaborated deal's stitched team-conversation copies, so the newest
 * message a user sees may live in a *sibling* mailbox copy (e.g. a carrier reply that reached only
 * the collaborator). Passing this id makes the draft reference exactly what the user is looking at,
 * rather than the newest message in the local copy alone. Messages arrive ordered by date ascending,
 * so the last one is newest. Returns undefined when messages aren't loaded (e.g. the inbox-list
 * fragment), in which case the caller falls back to `conversationId`.
 */
export const latestThreadMessageId = (
  messages: InboxConversationFragment["messages"] | undefined
): string | undefined => (messages && messages.length > 0 ? messages[messages.length - 1].id : undefined);
